export const customStyle = `
    .ant-table-wrapper .ant-table-thead  .ant-table-cell{
        background-color: #ffffff;

    }
`;
